export const AvatarNavbarFamousPersonalitiesIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91912)">
        <path
          d="M9.38 15.21H11.04"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M17.35 12.66C16.4 16.13 13.57 19.37 10.21 19.37C6.86 19.37 4.03 16.11 3.07 12.66"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M3.14 6.04C4.17 3.13 6.95 1.04 10.21 1.04C13.48 1.04 16.25 3.13 17.28 6.04"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M5.21 12.71H3.54C2.16 12.71 1.04 11.59 1.04 10.21V7.71C1.04 6.79 1.79 6.04 2.71 6.04H6.87C7.8 6.04 8.54 6.79 8.54 7.71V9.37C8.54 11.22 7.05 12.71 5.21 12.71Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M15.21 12.71H16.88C18.26 12.71 19.38 11.59 19.38 10.21V7.71C19.38 6.79 18.63 6.04 17.71 6.04H13.54C12.62 6.04 11.88 6.79 11.88 7.71V9.37C11.88 11.22 13.37 12.71 15.21 12.71Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.54 7.71H11.87"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91912">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
